import { render, staticRenderFns } from "./Causacion.vue?vue&type=template&id=072ecd83"
import script from "./Causacion.vue?vue&type=script&lang=js"
export * from "./Causacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports